import React from 'react'

import './Home.css'
import Product from './Product'
 //  https://images-eu.ssl-images-amazon.com/images/G/02/digital/video/merch2016/Hero/Covid19/Generic/GWBleedingHero_ENG_COVIDUPDATE__XSite_1500x600_PV_en-GB._CB428684220_.jpg
function Home() {
    return (
        <div className="home">
        <div className="home_cont">
             <img
          className="home_image"
          src="https://media.istockphoto.com/photos/online-shopping-and-payment-man-using-tablet-with-shopping-cart-icon-picture-id1206800961?k=20&m=1206800961&s=612x612&w=0&h=hcPoUKhWtzHXR3PIAHVgPVZDZaO7R8yZ1wNPkUSsgwU="
          alt=""
        />
       
        </div>
          <div className="row">
              <Product title="The Lean Startup: How Constant Innovation Creates Radically Successful Businesses Paperback"
                       price={11.96}
                       img_url="https://images-na.ssl-images-amazon.com/images/I/51Zymoq7UnL._SX325_BO1,204,203,200_.jpg"
                       rating={4}/>
              <Product
                       title="Kenwood kMix Stand Mixer for Baking, Stylish Kitchen Mixer with K-beater, Dough Hook and Whisk, 5 Litre Glass Bowl"
                       price={239.0}
                       
                       img_url="https://images-na.ssl-images-amazon.com/images/I/81O%2BGNdkzKL._AC_SX450_.jpg"
                       rating={4}
                                     />
          </div>
          <div className="row">
              <Product
                    title="Samsung LC49RG90SSUXEN 49' Curved LED Gaming Monitor"
                    price={199.99}
                    rating={3}
                    img_url="https://images-na.ssl-images-amazon.com/images/I/71Swqqe7XAL._AC_SX466_.jpg"/>
              <Product
                  title="Amazon Echo (3rd generation) | Smart speaker with Alexa, Charcoal Fabric"
                  price={98.99}
                  rating={5}
                  img_url="https://media.very.co.uk/i/very/P6LTG_SQ1_0000000071_CHARCOAL_SLf?$300x400_retinamobilex2$"/>
              <Product
                  title="New Apple iPad Pro (12.9-inch, Wi-Fi, 128GB) - Silver (4th Generation)"
                  price={598.99}
                  rating={4}
                  img_url="https://images-na.ssl-images-amazon.com/images/I/816ctt5WV5L._AC_SX385_.jpg"/>
          </div>
           <div className="row">
              <Product
                   title="Samsung LC49RG90SSUXEN 49' Curved LED Gaming Monitor - Super Ultra Wide Dual WQHD 5120 x 1440"
                    price={1094.98}
                   rating={4}
                   img_url="https://images-na.ssl-images-amazon.com/images/I/6125mFrzr6L._AC_SX355_.jpg"/>
              
          </div>
         
        </div>
        
    )
}

export default Home
